module.exports = __webpack_public_path__ + "img/fangan-bg.2bf79e9b.png";